import React, { useContext, useEffect, useRef, useState } from 'react'
import TopNavbar from '../../CommonComponent/topNavbar/TopNavbar'
import Sidebar from '../../CommonComponent/sidebar/Sidebar'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuctionBYIdGet, AuctionGetTeam, BidReg, BidAuctionTeamWinner, UserGetId, getBIdCount, RefreshToken, BidStatus, AuctionAll, SmBidReg, SecondryMarketSMgetAuctionById } from '../../redux/auth-reducer/auth-service'
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs'
import Modal from 'react-bootstrap/Modal';
import soundFile from './sound.mp3';
import soundFileBid from './sound-bid.mp3';
import * as signalR from "@microsoft/signalr";
import { ImageUrl, SignalRUrl } from '../../utils/config/config'
import { Context } from '../../redux/Context'
import moment from 'moment'

export const SecodaryPlaceBid = () => {

    const [data, setData] = useState(false);
    const [validated, setValidated] = useState(false);
    const [auctionList, setAuctionList] = useState([]);
    const [bidCountList, setBidCountList] = useState();
    const [userData, setUserData] = useState();
    const [oldBidAmount, setOldBidAmount] = useState();
    const [errorMessage, setErrorMessage] = useState(false)
    const [auctionIdData, setAuctionIdData] = useState();
    const [teamList, setTeamList] = useState();
    const [disabled, setDisabled] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const { state } = useLocation()
    const [minutes, setMinutes] = useState(0);
    const [CurrentBidAmount, setCurrentBidAmount] = useState();
    const [seconds, setSeconds] = useState(1);
    const [show, setShow] = useState(false);
    const [bidWinner, setBidWinner] = useState([]);
    const intervalRef = useRef(null);
    const [signalRData, setSignalRData] = useState([]);
    // const [hubConnection, setHubConnection] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [bidStatusAuction, setBidStatusAuction] = useState();
    const [currentTotalPlaceBId, setCurrentTotalPlaceBId] = useState();
        const [placeBid, setPlaceBid] = useState(null);
        const [placeBidTeamId, setPlaceBidTeamId] = useState(null);
  const [dataListItemSingnalR,setDataListItemSingnalR] =useState();
    const { hubConnection } = useContext(Context);


    // useEffect(() => {

    //     if (minutes === 0 && seconds == 0) {

    //         const audio = new Audio(soundFile);
    //         audio.play().catch(error => {
    //             console.error("Error playing sound:", error);
    //         });
    //     }

    // }, [minutes, seconds]);


    useEffect(() => {
        let audio;
        if (minutes === 0 && seconds === 0) {
            audio = new Audio(soundFile);
            audio.play().catch(error => {
                console.error("Error playing sound:", error);
            });

            // Stop the sound after 3 seconds
            const timeoutId = setTimeout(() => {
                audio.pause();
                audio.currentTime = 0;
            }, 3000); // 3000 milliseconds = 3 seconds


            return () => {
                clearTimeout(timeoutId);
                if (audio) {
                    audio.pause();
                    audio.currentTime = 0;
                }
            };
        }
    }, [minutes, seconds]);



    useEffect(() => {
        let audioBId;
        if (minutes === 0 && seconds === 3) {
            audioBId = new Audio(soundFileBid);
            audioBId.play().catch(error => {
                console.error("Error playing sound:", error);
            });

            // Stop the sound after 3 seconds
            const timeoutId = setTimeout(() => {
                audioBId.pause();
                audioBId.currentTime = 0;
            }, 8000); // 3000 milliseconds = 3 seconds


            return () => {
                clearTimeout(timeoutId);
                if (audioBId) {
                    audioBId.pause();
                    audioBId.currentTime = 0;
                }
            };
        }
    }, [minutes, seconds]);




    useEffect(() => {
        const storedState = JSON.parse(localStorage.getItem('timerState'));
        if (storedState) {
            setMinutes(storedState.minutes);
            setSeconds(storedState.seconds);
        }
    }, []);


    // useEffect(() => {
    //     if (minutes === 0 && seconds === 0) {
    //         handleShow()
    //     }
    // }, [minutes, seconds])


    // const handleClose = () => navigate("/Player/SecodaryBid");
    const handleClose = () => navigate("/Player/Secondary_Market");


    const [regForm, setRegForm] = useState({
        bidId: 0,
        auctionId: 0,
        teamId: Number,
        startingBid: 0,
        bidTime: 0,
        totalPlacedBids: 0,
        bidIncrement: 0,
        currentBidAmount: 0,
        bidAmount: 0,
        bidPlacedBy: 0
    });

    const navigate = useNavigate()

    const isUser = JSON.parse(localStorage.getItem('isUser'));
    const userId = isUser.userId;

    // useEffect(() => {
    //     async function UserGet() {
    //         await UserGetId().then((res) => {
    //             setUserData(res?.id);

    //         })
    //     }
    //     UserGet();
    // }, []);

    const sidebarfun = () => {
        setData(!data)
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        setValidated(true);

        // if (state?.bidIncrement + state?.startingBid > oldBidAmount) {
        //     setErrorMessage(true)
        // }
        //  else {
        const registerData = [{
            // "crudOperationId": true,
            // "bidId": 0,
            "teamId": Number(state?.teamId),
            "auctionId": state?.auctionId,
            "startingBid": state?.startingBid,
            "bidTime": state?.bidTime,
            "totalPlacedBids": state?.totalPlacedBids,
            "bidIncrement": state?.bidIncrement,
            "currentBidAmount": Number(currentTotalPlaceBId?.currentBidAmount),
            "bidAmount": Number(oldBidAmount) || state?.startingBid,
            // "bidPlacedBy": Number(userId),
            "ownerShipShare": Number(state?.ownerShipShare),
        }]

        await SmBidReg(registerData).then((res) => {

            if (res?.data?.status == true) {


                toast.success(res?.data?.message);

                // setDisabled(true);
                // navigate('/Player/SecodaryBid');

            }
            else {
                toast.error(res?.data?.message);
            }
        })
        // }

    };

 

    useEffect(() => {

        const AuctionID = async () => {
            await SecondryMarketSMgetAuctionById(state).then((response) => {
                setCurrentTotalPlaceBId({ ...response, remainingBidTime: state.recievedAt, totalPoolAmount: state?.totalPoolAmount, })
                setAuctionIdData(response?.auctionId)
                setAuctionList(response);
                setCurrentBidAmount(response?.bidIncrement + response?.minBid)
                setOldBidAmount(response?.bidIncrement + response?.minBid);
            })
        }
        AuctionID();

    }, [])



    useEffect(() => {

        const AuctionID = async () => {
            // await AuctionBYIdGet(state).then((response) => {
            setCurrentTotalPlaceBId({ ...state, remainingBidTime: state.recievedAt, totalPoolAmount: state?.totalPoolAmount, totalPlacedBids: state?.totalPlacedBids, currentBidAmount: state?.currentBidAmount, teamName: state?.teamName, startingBid: state?.startingBid })
            // setAuctionIdData(response?.auctionId)
            // setAuctionList(response);
            // setCurrentBidAmount(response?.bidIncrement + response?.minBid)
            // setOldBidAmount(response?.bidIncrement + response?.minBid);
            // })
        }
        AuctionID();

    }, [])

    // useEffect(() => {

    //     const GetTeamList = async () => {
    //         await AuctionGetTeam(auctionIdData).then((response) => {
    //             setTeamList(response?.data)

    //         })
    //     }
    //     GetTeamList();

    // }, [auctionIdData])

    // useEffect(() => {

    //     const BidCount = async () => {
    //         await getBIdCount().then((response) => {
    //             setBidCountList(response);

    //         })
    //     }
    //     BidCount();

    // }, [])

    var customId = [1, 2, 5, 6]

    const handelBid = (e) => {
        setRegForm({
            ...regForm,
            [e.target.name]: e.target.value
        }
        )
    }

    const handelBidAmount = (e) => {
        setErrorMessage(false);
        const value = e.target.value;
        if (value >= 0) {
            setInputValue(value);
        }
        // if (e.target.value.length > 6) {
        //     window.alert("Bid amount should not exceed 6 digits");
        // }

        setDisabled(isNaN(value));
        setOldBidAmount(e.target.value);
    }


    function addZero(num) {

        if (num < 10) {
            return `0${num}`
        }
        return num

    }


    useEffect(() => {
        const updateTime = (time) => {
  
            // if(!time) return
            const [minutesStr, secondsStr] = time?.split(':') ?? [0, 0];
            const updatedMinutes = parseInt(minutesStr, 10);
            const updatedSeconds = parseInt(secondsStr, 10);

            // Only set state if values are valid
            if (!isNaN(updatedMinutes) && !isNaN(updatedSeconds)) {
                setMinutes(updatedMinutes);
                setSeconds(updatedSeconds);
              
                if (minutes === 0 && seconds === 0) {
                  
                    // handleShow(); // Trigger any action on zero
                }
                if (updatedMinutes === 0 && updatedSeconds === 0) {
                    setDisabled(true)
                }
            }
        };

        function getLeaveTime(end) {
            var diffDays = (new Date(end)).getTime() - (new Date()).getTime()

            // // duration in minutes
            var minutes = parseInt(diffDays / (1000 * 60));

            var seconds = parseInt(diffDays / 1000);
          
            if (minutes == 0 && new Date(diffDays).getSeconds() == 0) {
                setShow(true);
                // auctionTeamWinner(state.auctionId, state.teamId)
            }
            return diffDays > 0 ? `${diffDays > 0 ? addZero(minutes) : "00"}:${diffDays > 0 ? addZero(new Date(diffDays).getSeconds()) : "00"}` : ""
        }

        // Manage bid time initialization logic
        if (currentTotalPlaceBId === undefined) {
            if (state.remainingBidTime === "00:01") {
                setMinutes(state.bidTime);
          

            }
            else {
             
                updateTime(getLeaveTime(state.recievedAt));
                // updateTime(currentTotalPlaceBId?.remainingBidTime);
            }
        } else {
            if (state.remainingBidTime === "00:01") {
                // setMinutes(state.bidTime);
              
            } else {
                updateTime(getLeaveTime(currentTotalPlaceBId?.remainingBidTime));
              

            }
        }


        if (currentTotalPlaceBId?.remainingBidTime === '00:00') {
            hubConnection.stop().then(() => {
      
            }).catch((error) => {
               
            });
        }

    }, [state, currentTotalPlaceBId, hubConnection]);


    useEffect(() => {
        if (minutes === 0 && seconds === 0) {
            setShow(true);
            setTimeout(() => {
                setShow(false);
                navigate("/Player/Secondary_Market")
            }, [2000])
            // auctionTeamWinner(state.auctionId, state.teamId)
        }
    }, [minutes, seconds])



    const handleShow = () => {
        if (!show) {
            setShow(true);
            // auctionTeamWinner(state.auctionId, state.teamId)
        }
    };



    useEffect(() => {
        if (state.bidTime == 0.5) {
            if (minutes === 0 && seconds === 0) {
                clearInterval(intervalRef.current);
            } else {
                intervalRef.current = setInterval(() => {
                    if (seconds === 0) {
                        if (minutes === 0) {
                            clearInterval(intervalRef.current);
                        } else {
                            setMinutes(0);
                            setSeconds(29);
                        }
                    } else {
                        setSeconds((prevSeconds) => prevSeconds - 1);
                    }
                }, 1000);
                return () => {
                    clearInterval(intervalRef.current);
                };
            }
        } else {
            if (minutes === 0 && seconds === 0) {
                clearInterval(intervalRef.current);
            } else {
                intervalRef.current = setInterval(() => {
                    if (seconds === 0) {
                        if (minutes === 0) {
                            clearInterval(intervalRef.current);
                        } else {
                            setMinutes((prevMinutes) => prevMinutes - 1);
                            setSeconds(59);
                        }
                    } else {
                        setSeconds((prevSeconds) => prevSeconds - 1);
                    }
                }, 1000);
                return () => {
                    clearInterval(intervalRef.current);
                };
            }
        }
    }, [minutes, seconds, state]);




    useEffect(() => {
        const storedState = JSON.parse(localStorage.getItem('timerState'));
        if (storedState) {
            setMinutes(storedState.minutes);
            setSeconds(storedState.seconds);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('timerState', JSON.stringify({ minutes, seconds }));
    }, [minutes, seconds]);

    useEffect(() => {
        return () => {
            localStorage.removeItem('timerState');
        };
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('timerState')) {
            setMinutes(5);
            setSeconds(0);
        }
    }, []);






    useEffect(() => {
        if (hubConnection) {
            // Listen for messages from the SignalR hub
            hubConnection.on("ReceiveSMBidStatus", (data) => {
            

                data.map((item) => {
                   
                 
                    // else {
                    if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                        // let remainingtimer = moment().add(item?.remainingBidTime.split(":")[0], 'minutes').add(item?.remainingBidTime.split(":")[1], 'seconds').format()
                        // setCurrentTotalPlaceBId(item)
                        setCurrentTotalPlaceBId((e) => {
                            return { ...item, remainingBidTime: e.remainingBidTime }
                        })
                    }
                    // }


                })
                setSignalRData(data);
            });



            return () => {
                hubConnection.off("ReceiveBidStatus");
            };
        }
    }, [hubConnection]);


    useEffect(() => {
        if (hubConnection) {
            hubConnection.on("ReceiveCurrentSMBid", (data) => {
        
                setDataListItemSingnalR(data)
                // setCurrentTotalPlaceBId(data)
                data.map((item) => {
                 
                
                   
                    if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                        let remainingtimer = moment().add(item?.remainingBidTime.split(":")[0], 'minutes').add(item?.remainingBidTime.split(":")[1], 'seconds').format()
                        setCurrentTotalPlaceBId({ ...item, remainingBidTime: remainingtimer })
                    }
                 


                })
            });
            return () => {
                hubConnection.off("ReceiveCurrentBid");

            };
        }
    }, [hubConnection]);






   
    
  
    
    
    var getId = localStorage.getItem("placebid");

    var getTeamId = localStorage.getItem("placeTeamId");

 

    useEffect(() => {
        const idPlaceBId = dataListItemSingnalR?.map((item) => (
            item?.bidPlacedBy
        ))

        // Read from localStorage when component mounts
        let storedPlaceBid = localStorage.getItem("placebid");
        if (storedPlaceBid) {
            setPlaceBid(storedPlaceBid);
        
        }

        // Check if dataListItemSingnalR is empty
        if (dataListItemSingnalR?.length === 0) {
          
        } else {
            // If the array is not empty, check if idPlaceBId is valid
            if (idPlaceBId) {
                localStorage.setItem("placebid", idPlaceBId);
                setPlaceBid(idPlaceBId); // Update state with the new value
      
            } else {
       
            }
        }
    }, [dataListItemSingnalR]);

    useEffect(() => {
        const idPlaceTeamId = dataListItemSingnalR?.map((item) => (
            item?.teamId
           ))
        // Read from localStorage when component mounts
        let storedPlaceBid = localStorage.getItem("placeTeamId");
        if (storedPlaceBid) {
            setPlaceBidTeamId(idPlaceTeamId);
        
        }

        // Check if dataListItemSingnalR is empty
        if (dataListItemSingnalR?.length === 0) {
          
        } else {
            // If the array is not empty, check if idPlaceBId is valid
            if (idPlaceTeamId) {
                localStorage.setItem("placeTeamId", idPlaceTeamId);
                setPlaceBidTeamId(idPlaceTeamId); // Update state with the new value
       
            } else {
       
            }
        }
    }, [dataListItemSingnalR]);




    return (
        <>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Bid Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        currentTotalPlaceBId?.bidPlacedBy == userId  || getId == userId && getTeamId == state?.teamId ? <h4><span className='text-success'>Congratulations,</span>You won the auction</h4> : <h4>Sorry, You lost the auction</h4>
                    }
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        OK
                    </Button>

                </Modal.Footer> */}
            </Modal>

            <TopNavbar sidebarfun={sidebarfun} />
            <div className="dasboard-group" >
                <Sidebar data={data} />
                <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>

                    <Row>
                        <Col md={6}><h1 className="heading-dash">  Place Bid </h1></Col>
                    </Row>
                    <div className='group_data_table p-3'>
                        <Row>
                            <Col md={6}>

                                <Form noValidate validated={validated} >
                                    <Form.Group as={Col} md="12 mt-3" className="text-left " controlId="validationCustomCountry">
                                        <Form.Label>Team</Form.Label>

                                        <InputGroup hasValidation>

                                            <Form.Control
                                                type="text"
                                                name="teamId"
                                                disabled
                                                value={currentTotalPlaceBId == undefined ? state?.teamName : currentTotalPlaceBId?.teamName}
                                                style={{ height: "46px" }}
                                                aria-describedby="inputGroupPrepend"
                                                required
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                Please a select Team name.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    <Row>

                                        <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                            <Form.Label className="mt-3">  {state?.totalPlacedBids == 0 ? "Start Bid" : "Last Bid"}</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="minBid"
                                                    disabled
                                                    value={currentTotalPlaceBId == undefined ? state?.startingBid : currentTotalPlaceBId?.startingBid}
                                                    style={{ height: "46px" }}
                                                 
                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please Enter a Minimum Bid.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                            <Form.Label className="mt-3">Bid Time Limit</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="bidTimeLimit"
                                                    style={{ height: "46px" }}
                                                    disabled
                                                    value={currentTotalPlaceBId == undefined ? state?.bidTime : currentTotalPlaceBId?.bidTime}
                                              
                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please Enter a Bid Time Limit.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                            <Form.Label className="mt-3">Total Placed Bids</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="bidPlacedBy"
                                                    style={{ height: "46px" }}
                                                    disabled
                                                    // value={state?.totalPlacedBids}
                                                    value={currentTotalPlaceBId == undefined ? state?.totalPlacedBids : currentTotalPlaceBId?.totalPlacedBids}
                                                 
                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please Enter a Placed Bids.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                            <Form.Label className="mt-3">Minimum Bid Increment</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="text"
                                                    name="bidIncrement"
                                                    style={{ height: "46px" }}
                                                    disabled
                                                    value={state?.bidIncrement}

                                                    aria-describedby="inputGroupPrepend"
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please Enter a Minimum Bid Increment.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>


                                        <Col md="6">
                                            <Form.Label className="mt-3">Minimum Next Bid </Form.Label>
                                            <h2 className='currentBid'>
                                                {/* {state?.totalPlacedBids === 0 ? state?.startingBid : currentTotalPlaceBId?.startingBid + state?.bidIncrement} */}
                                                {currentTotalPlaceBId?.currentBidAmount}
                                                {/* {currentTotalPlaceBId == undefined ? state?.startingBid : currentTotalPlaceBId.startingBid + state?.bidIncrement} */}
                                            </h2>
                                        </Col>
                                        <Col md="6" className='mt-3'>
                                            <Form.Group controlId="validationCustomFristname">
                                                <Form.Label >Custom Bid Amount</Form.Label>
                                                <InputGroup hasValidation>
                                                    <Form.Control
                                                        type="number"
                                                        style={{ height: "46px" }}
                                                        name="bidAmount"
                                                        // minLength={6}
                                                        onChange={handelBidAmount}
                                                        placeholder="Enter your custom bid amount"
                                                        aria-describedby="inputGroupPrepend"
                                                    // inputProps={{ maxLength: 6 }}
                                                    />

                                                </InputGroup>

                                            </Form.Group>

                                            {errorMessage == true ? <p className='err-message'>
                                                Bid Amount should be equal and greater than Minimum Next Bid.
                                            </p> : ""}
                                            <p className='mt-2'>    All Bidding Amount is in USD</p>



                                        </Col>

                                        <Form.Group as={Col} md="5">
                                            {/* {
                                                currentTotalPlaceBId?.startingBid===NaN ?"": <Button type='button' disabled={disabled} onClick={handleSubmit} className='update-btn-prof mt-3 ms-0'>Place My Bid</Button>
                                            } */}

                                            {
                                                isNaN(currentTotalPlaceBId?.startingBid) ? "" :
                                                    minutes === 0 && seconds === 0 ?
                                                        <Button type='button' disabled onClick={handleSubmit} className='update-btn-prof  ms-0'>Place My Bid</Button> : <Button type='button' disabled={currentTotalPlaceBId?.bidPlacedBy == userId || getId == userId && getTeamId == state?.teamId} onClick={handleSubmit} className='update-btn-prof ms-0'>Place My Bid</Button>
                                            }
                                            {currentTotalPlaceBId?.bidPlacedBy == userId || getId == userId && getTeamId == state?.teamId ? <>

                                                <p class="bidWinner mt-3">You are the highest bidder</p>

                                            </> : ""}

                                        </Form.Group>







                                    </Row>
                                </Form>

                                <div className='border-right'></div>
                            </Col>
                            <Col md={6}>
                                <div className='placeBid-sec'>
                                    <h2 className='text-white'>
                                        {state?.auctionName}
                                        - {state?.teamName}
                                    </h2>
                                    {
                                        state?.teamImage == null ? <img src='/image/team-icon.png' width={100}></img> : <img src={ImageUrl + state?.teamImage} width={100}></img>
                                    }

                                    <div className='group-auctionBid-date'>
                                        {show ? (
                                            <Col md={12}>
                                                <p>Bidding Ended</p>
                                            </Col>
                                        ) : (
                                            <Row>
                                                <Col md={12}>
                                                    <span style={{ color: minutes === 0 && seconds <= 10 ? 'red' : 'white' }}>
                                                        {minutes?.toString().padStart(2, '0')}:{seconds?.toString().padStart(2, '0')}
                                                    </span>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>

                                    {
                                        state?.auctionImage == null ? <img src="../image/auctionImage.png" className='ImageAuction_bid' /> : <img src={ImageUrl + state?.auctionImage} className='img-fluid' width={200}></img>
                                    }
                                </div>
                            </Col>
                        </Row>

                    </div>

                </div>
            </div>
        </>
    )
}


